import Text from '@components/Text/Text';
import { BoxProps } from '@mui/material';
import React from 'react';
import {
  FlexPlaceholder,
  FlexPlaceholdersContainer,
  Logo,
  LogoTitleContainer,
  StyledBoxContainer,
} from './HeroLinearImage.style';
import SwiseLogo from '@assets/logos/swise_white_on_dark.svg';
import Flex from '@components/Flex/Flex';

interface HeroLinearImageProps extends BoxProps {
  image: string;
  message?: string;
  hideLogo?: boolean;
}

const HeroLinearImage: React.FC<HeroLinearImageProps> = ({
  image,
  message,
  hideLogo = false,
  ...restProps
}) => {
  return (
    <Flex>
      <StyledBoxContainer image={image} {...restProps}>
        <LogoTitleContainer>
          {!hideLogo && <Logo alt='Hero-Linear-Logo' src={SwiseLogo} />}
          {message && (
            <Text variant='h5' fontWeight='fontWeightSemiBold'>
              {message}
            </Text>
          )}
        </LogoTitleContainer>

        {/* Placeholders used to prevent the InfoCards from overlapping the message above */}
        <FlexPlaceholdersContainer>
          <FlexPlaceholder />
          <FlexPlaceholder />
          <FlexPlaceholder />
        </FlexPlaceholdersContainer>
      </StyledBoxContainer>
    </Flex>
  );
};

export default HeroLinearImage;
